module.exports = __webpack_public_path__ + "img/logo_.5338ce19.svg";